import { calculateReadingTime } from "utils/reading-time";

const readingTimeResolver = (
    body: string,
    readTimeMins: number | null,
    introText: string | null
): number => {
    if (readTimeMins) {
        return readTimeMins;
    }

    return (
        (introText
            ? calculateReadingTime(introText + body).minutes
            : calculateReadingTime(body).minutes) || 1
    );
};

export default readingTimeResolver;
